import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBackfillListeningScoresV1Response } from './backfill-listening-scores-v1-response';
import { backfillListeningScoresV1ResponseSchema } from './backfill-listening-scores-v1-response';

export async function backfillListeningScoresV1Api(): Promise<
  IValidatedResponse<IBackfillListeningScoresV1Response>
> {
  return postRequest<IBackfillListeningScoresV1Response>({
    path: '/sys/listening/v1/backfill',
    schema: backfillListeningScoresV1ResponseSchema,
  });
}
